<script setup>
// "Instalar o advup" na folha "Mais" do celular (06/10/2026) — ver
// `composables/useInstalarApp.js`. Some quando o app já está instalado.
// Android: abre a instalação do próprio Chrome. iPhone: o passo a passo do
// Safari (Compartilhar → Adicionar à Tela de Início), que é o que destrava
// as notificações no iOS.
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useInstalarApp } from 'dashboard/composables/useInstalarApp';

const { t } = useI18n();
const { modo, instalar } = useInstalarApp();
const passoAPassoAberto = ref(false);

const aoTocar = () => {
  if (modo.value === 'nativo') instalar();
  else passoAPassoAberto.value = true;
};
const fechar = () => {
  passoAPassoAberto.value = false;
};

const PASSOS = [
  { icone: 'i-lucide-share', chave: 'PASSO_1' },
  { icone: 'i-lucide-square-plus', chave: 'PASSO_2' },
  { icone: 'i-lucide-check', chave: 'PASSO_3' },
];
</script>

<template>
  <div v-if="modo" class="inst">
    <button type="button" class="inst__linha" @click="aoTocar">
      <span class="inst__selo" aria-hidden="true">
        <i class="i-lucide-smartphone" />
      </span>
      <span class="inst__textos">
        <span class="inst__tit">{{ t('SIDEBAR.INSTALAR.TITULO') }}</span>
        <span class="inst__sub">{{ t('SIDEBAR.INSTALAR.SUB') }}</span>
      </span>
      <i class="i-lucide-chevron-right inst__seta" aria-hidden="true" />
    </button>

    <Teleport to="body">
      <div
        v-if="passoAPassoAberto"
        class="advup-modal-fundo inst-fundo"
        @click.self="fechar"
      >
        <div
          v-modal-acessivel="fechar"
          class="advup-modal advup-modal--claro"
          role="dialog"
          aria-modal="true"
          :aria-label="t('SIDEBAR.INSTALAR.IPHONE_TITULO')"
        >
          <div class="advup-modal__topo">
            <span class="advup-modal__selo" aria-hidden="true">
              <i class="i-lucide-smartphone" />
            </span>
            <div class="min-w-0 flex-1">
              <h2 class="advup-modal__titulo">
                {{ t('SIDEBAR.INSTALAR.IPHONE_TITULO') }}
              </h2>
              <p class="advup-modal__sub advup-modal__sub--solta">
                {{ t('SIDEBAR.INSTALAR.IPHONE_SUB') }}
              </p>
            </div>
            <button
              type="button"
              class="advup-modal__fechar"
              :aria-label="t('SIDEBAR.INSTALAR.FECHAR')"
              @click="fechar"
            >
              <i class="i-lucide-x" aria-hidden="true" />
            </button>
          </div>
          <div class="advup-modal__corpo">
            <ol class="inst__passos">
              <li v-for="(passo, i) in PASSOS" :key="passo.chave">
                <span class="inst__num">{{ i + 1 }}</span>
                <i
                  :class="passo.icone"
                  class="inst__icone"
                  aria-hidden="true"
                />
                <span>{{ t(`SIDEBAR.INSTALAR.${passo.chave}`) }}</span>
              </li>
            </ol>
          </div>
          <div class="advup-modal__rodape advup-modal__rodape--acoes">
            <button
              type="button"
              class="advup-btn advup-btn-forte"
              @click="fechar"
            >
              {{ t('SIDEBAR.INSTALAR.ENTENDI') }}
            </button>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<style scoped>
.inst {
  padding: 4px 12px 8px;
}

.inst__linha {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgb(var(--blue-3)), rgb(var(--iris-3)));
  text-align: left;
}

.inst__linha:active {
  transform: scale(0.98);
}

.inst__selo {
  display: grid;
  flex: none;
  place-items: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgb(var(--blue-9));
  color: #fff;
}

.inst__textos {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}

.inst__tit {
  color: rgb(var(--slate-12));
  font-size: 14px;
  font-weight: 600;
}

.inst__sub {
  color: rgb(var(--slate-11));
  font-size: 12px;
}

.inst__seta {
  flex: none;
  width: 18px;
  height: 18px;
  color: rgb(var(--slate-10));
}

/* Acima da folha "Mais" (99980). */
.inst-fundo {
  --modal-camada: 99990;
}

.inst__passos {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.inst__passos li {
  display: flex;
  align-items: center;
  gap: 12px;
  color: rgb(var(--slate-12));
  font-size: 15px;
  line-height: 1.4;
}

.inst__num {
  display: grid;
  flex: none;
  place-items: center;
  width: 26px;
  height: 26px;
  border-radius: 999px;
  background: rgb(var(--blue-3));
  color: rgb(var(--blue-11));
  font-size: 13px;
  font-weight: 700;
}

.inst__icone {
  flex: none;
  width: 20px;
  height: 20px;
  color: rgb(var(--blue-10));
}
</style>
